import { render, staticRenderFns } from "./dashboard-org_professional.vue?vue&type=template&id=1386ba99&scoped=true"
import script from "./dashboard-org_professional.vue?vue&type=script&lang=js"
export * from "./dashboard-org_professional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386ba99",
  null
  
)

export default component.exports